import * as React from 'react';
import classnames from 'classnames';
import Flex, { Props as FlexProps } from '../Flex/Flex';
import './Input.css';

export interface Props extends FlexProps {
  /** Sets specific styling for if the content appears inside or
   * outside the input element.
   */
  outside?: boolean;
}

/**
 * The content component that holds input content like the Input element
 * or icons.
 */
const InputContent: React.FunctionComponent<Props> = (props: Props) => {
  const { outside, ...rest } = props;
  const classes = classnames('Input__content', {
    'Input__content--outside': outside,
  });

  return (
    <Flex { ...rest }
        alignChildrenVertical="middle"
        className={ classes }
        direction="horizontal"
        gap="x2"
        grow={ !outside } />
  );
};

export default InputContent;
